import { h } from 'preact'

export const SeoKeywords = ({ title, keywords, cacheKey }) => {
   return (
      <div class="bg-gray2" id="zone_seo_keywords" data-testid="bande-seo" data-cache-key={cacheKey}>
         <div class="container-fluid">
            <div class="row no-gutters py-1 text-black">
               <div class="col-12">
                  {title !== '' ? <h2 class="lead no-signature font-weight-bold d-block mb-0">{title}</h2> : null}
                  <p class="small">{keywords}</p>
               </div>
            </div>
         </div>
      </div>
   )
}
